<template>
    <div class="case-study-three-images flex flex-col md:flex-row justify-start md:justify-between items-center md:items-start max-w-3xl mx-auto px-10">
        <img :data-srcset="image.imageOne[0].url" class="lazyload border-solid border md:mt-0 flex-no-grow flex-shrink w-full md:w-28p" />
        <img :data-srcset="image.imageTwo[0].url" class="lazyload border-solid border mt-14 md:mt-0 flex-no-grow flex-shrink w-full md:w-28p" />
        <img :data-srcset="image.imageThree[0].url" class="lazyload border-solid border mt-14 md:mt-0 flex-no-grow flex-shrink w-full md:w-28p" />
    </div>
</template>

<script>
    export default {
        name : 'case-study-three-images',

        props : {
            block : {
                type : Object,
                default : () => {}
            }
        },

        computed : {
            image(){
                return this.block.caseStudyImagesThreeImages[0];
            }
        },

        mounted(){
        }
    }
</script>

<style lang="scss">
    .case-study-three-images {
        box-sizing: inherit;

        img {
            border-color : rgba(190,190,190,0.4);
        }
    }
</style>